export default function formatMultiple(
  items: string[],
  t: (key: string) => string,
) {
  if (items.length === 0) return "";
  if (items.length === 1) return items[0];

  const separator = t("list.separator");
  const lastSeparator = t("list.lastSeparator");

  const allButLast = items.slice(0, -1).join(separator);
  const lastItem = items[items.length - 1];

  return `${allButLast} ${lastSeparator} ${lastItem}`;
}
